import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getAuditHistoryReturnList = createAsyncThunk(
  "get-audit-history",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.get(`audit/history/${id}`, { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const auditHistorySlice = createSlice({
  name: "auditHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAuditHistoryReturnList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAuditHistoryReturnList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.auditList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getAuditHistoryReturnList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default auditHistorySlice.reducer;
